import {
  type AutomationTemplateId,
  AutomationTemplateIds,
} from "@repo/app-types/entities/automation";
import type { TablerIcon } from "@tabler/icons-react";
import {
  IconClipboardCheck,
  IconFlame,
  IconHeart,
  IconSparkles,
  IconTrendingUp,
  IconTrophy,
} from "@tabler/icons-react";

export const automationTemplateIcons: Record<AutomationTemplateId, TablerIcon> =
  {
    [AutomationTemplateIds.TEAMMATE_COACHING]: IconClipboardCheck,
    [AutomationTemplateIds.CUSTOMER_PRAISE_DIGEST]: IconHeart,
    [AutomationTemplateIds.PERFECT_CALLS]: IconTrophy,
    [AutomationTemplateIds.PLAYBOOK_SCORE_MOVEMENT]: IconTrendingUp,
    [AutomationTemplateIds.LEAD_BURNING]: IconFlame,
    [AutomationTemplateIds.CUSTOM]: IconSparkles,
  };
